module.exports = __webpack_public_path__ + "0723bb3be29f52e5b09014825952fd9a.svg";